import { render, staticRenderFns } from "./CreateLabelSetFromFiltersModal.vue?vue&type=template&id=3137ac22&scoped=true"
import script from "./CreateLabelSetFromFiltersModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelSetFromFiltersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137ac22",
  null
  
)

export default component.exports